import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { class: "full-table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "form-wrapper slide-up"
}
const _hoisted_8 = { class: "form-close" }
const _hoisted_9 = { style: {"margin-bottom":"5px"} }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showSig && _ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              style: {"width":"180px"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search())),
              placeholder: "Search"
            }, null, 544), [
              [_vModelText, _ctx.searchQ]
            ])
          ]),
          _createElementVNode("table", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatures, (sig, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(sig.UpdatedDateDisplay), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.viewSigs(sig)), ["prevent"])
                  }, _toDisplayString(sig.UserName), 9, _hoisted_6)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSig)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[3] || (_cache[3] = () => { _ctx.showSig = false })
            }, "×")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sigToView.SignOffs, (sig, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              style: {"margin-bottom":"10px"}
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("b", null, _toDisplayString(sig.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: sig.signatureData
                }, null, 8, _hoisted_10)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}